// Calls to admin_backend /admin/hrms/*. Responses are { status, msg, data };
// anything but status 200 is thrown as an Error(msg).
export const HRMS_BASE = `${process.env.REACT_APP_SERVER_URL}/admin/hrms`;

export async function hr(path, { method = "GET", body, form } = {}) {
  const opts = { method, credentials: "include" };
  if (form) opts.body = form;
  else if (body !== undefined) {
    opts.headers = { "Content-Type": "application/json" };
    opts.body = JSON.stringify(body);
  }
  const res = await fetch(`${HRMS_BASE}${path}`, opts);
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.status !== 200) throw new Error(json.msg || `Request failed (${res.status})`);
  return { data: json.data, msg: json.msg };
}

// Colour per person (stable for a name) and per leave type (by position).
const AVATAR_COLORS = ["#2563eb", "#7c3aed", "#db2777", "#0d9488", "#d97706", "#16a34a", "#0891b2", "#9333ea"];
export function avatarColor(seed = "") {
  let h = 0;
  for (const c of String(seed)) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
}
export const initials = (name = "") =>
  String(name)
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("") || "?";
export const COLORS = ["blue", "green", "violet", "amber", "teal", "pink"];

export const fileUrl = (path) => `${HRMS_BASE}${path}`;

export const fullName = (e) => (e ? [e.first_name, e.last_name].filter(Boolean).join(" ") : "");

export function fmtDate(d, opts = {}) {
  if (!d) return "—";
  const date = /^\d{4}-\d{2}-\d{2}$/.test(d) ? new Date(`${d}T00:00:00`) : new Date(d);
  return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric", ...opts });
}

export function fmtTime(d, timeZone) {
  if (!d) return "—";
  return new Date(d).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", timeZone });
}

export function fmtMinutes(m) {
  if (m == null) return "—";
  const h = Math.floor(m / 60);
  if (!h) return `${m % 60}m`;
  return `${h}h ${String(m % 60).padStart(2, "0")}m`;
}

export function inr(n) {
  if (n == null || n === "") return "—";
  return `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

export const days = (n) => (n == null ? "—" : `${Number(n)} day${Number(n) === 1 ? "" : "s"}`);

export const thisMonth = (today) => (today || new Date().toISOString()).slice(0, 7);

export function shiftMonth(ym, n) {
  const [y, m] = ym.split("-").map(Number);
  const d = new Date(Date.UTC(y, m - 1 + n, 1));
  return d.toISOString().slice(0, 7);
}

export const monthLabel = (ym) =>
  new Date(`${ym}-01T00:00:00`).toLocaleDateString("en-IN", { month: "long", year: "numeric" });

export const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const STATUS_LABELS = {
  onboarding: "Onboarding",
  active: "Active",
  notice: "Serving notice",
  exited: "Exited",
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  cancelled: "Cancelled",
  open: "Open",
  in_progress: "In progress",
  resolved: "Resolved",
};

export const DAY_STATUS = {
  present: { label: "Present", tone: "good" },
  late: { label: "Late", tone: "warn" },
  half_day: { label: "Half day", tone: "warn" },
  absent: { label: "Absent", tone: "bad" },
  leave: { label: "Leave", tone: "info" },
  half_leave: { label: "Half leave", tone: "info" },
  holiday: { label: "Holiday", tone: "muted" },
  weekly_off: { label: "Weekly off", tone: "muted" },
  missing_checkout: { label: "No check-out", tone: "warn" },
  future: { label: "", tone: "blank" },
  not_employed: { label: "", tone: "blank" },
  not_tracked: { label: "", tone: "blank" },
};

export const EMPLOYMENT_TYPES = { full_time: "Full time", part_time: "Part time", intern: "Intern", contract: "Contract" };
export const ROLE_LABELS = { employee: "Employee", hr: "HR", admin: "HRMS admin" };
export const GENDERS = ["Male", "Female", "Other", "Prefer not to say"];
export const DOC_CATEGORIES = {
  payslip: "Payslip",
  offer_letter: "Offer letter",
  contract: "Contract",
  id_proof: "ID proof",
  address_proof: "Address proof",
  education: "Education",
  experience: "Experience letter",
  policy: "Policy",
  other: "Other",
};
export const REQUEST_CATEGORIES = {
  letter: "Letter (address proof, experience…)",
  document: "Document",
  payroll: "Payroll / salary",
  it_access: "IT / access",
  policy: "Policy question",
  other: "Other",
};
